import { listPageSizeForHeight } from './listPageSize';

/** Grouped seeds carry hasMore, so the pager can replace a seed after a resize. */
export function groupedSeedPageSize(): number {
  const height = globalThis.innerHeight;
  return Number.isFinite(height) && height > 0
    ? Math.min(200, listPageSizeForHeight(height, globalThis.innerWidth < 768, true))
    : 100;
}

export function listSeedUrl(
  tableId: string,
  groupBy?: 'status',
  pageSize = groupedSeedPageSize()
): string {
  // One page fills the screen, so the seed loads groups until their rows fill
  // one page. A group below a full first group loads when it scrolls into view.
  return `/lists/${encodeURIComponent(tableId)}/seed?page=1&include_dashboard_links=true${groupBy ? `&group_by=status&page_size=${pageSize}&include_totals=true&opening_rows=${pageSize}` : ''}`;
}

/** The first page of the read of every row of a List, as `loadAllChildren` sends it. */
export function allRowsReadPath(listId: string, cursor?: string): string {
  const params = new URLSearchParams({ listId, paginate: 'cursor', page_size: '500' });
  if (cursor) params.set('cursor', cursor);
  return `/records?${params.toString()}`;
}
